"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryInvoiceInfo = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
class CountryInvoiceInfo {
    constructor() {
        this.isVat = false;
        this.vatPercentage = 0;
        this.isReverseCharge = false;
        this.invoiceCurrency = legacy_enums_1.Currency.Euro;
    }
}
exports.CountryInvoiceInfo = CountryInvoiceInfo;
//# sourceMappingURL=CountryInvoiceInfo.js.map